import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { useDeletePartnerDocumentMutation } from "Partners/Api/Mutations/useDeletePartnerDocumentMutation";
import { useUploadPartnerDocumentMutation } from "Partners/Api/Mutations/useUploadPartnerDocumentMutation";
import { usePartnerDocumentsQuery } from "Partners/Api/Queries/usePartnerDocumentsQuery";
import { DocumentsSection } from "Shared/Documents/DocumentsSection";

interface PartnerDocumentsSectionProps {
  partnerID: string;
}

export const PartnerDocumentsSection = ({
  partnerID,
}: PartnerDocumentsSectionProps): React.ReactNode => {
  const { t } = useResource();

  const { data, isLoading } = usePartnerDocumentsQuery(partnerID);
  const uploadMutation = useUploadPartnerDocumentMutation(partnerID);
  const deleteMutation = useDeletePartnerDocumentMutation(partnerID);

  return (
    <DocumentsSection
      title={t(Resources.Documents.SectionTitle)}
      documents={data?.items}
      isLoading={isLoading}
      onUpload={(file, displayName) =>
        uploadMutation.mutateAsync({ file, displayName })
      }
      isUploading={uploadMutation.isPending}
      onDelete={deleteMutation.mutateAsync}
    />
  );
};
